enum TaskStatus {
  todo = "未着手",
  doing = "着手中",
  done = "完了",
}

export default TaskStatus;
